'use client';

// Third Party
import * as React from 'react';
import dynamic from 'next/dynamic';

// Utils
import { ReferEarnDrawerProvider } from './use-refer-earn-drawer';

// Dynamically import the private component to avoid SSR issues
// This preserves static page generation while allowing client-side rendering
const ReferEarnDrawerPrivate = dynamic(
  () => import('./refer-earn-drawer-private'),
  { ssr: false }
);

/**
 * ReferEarnDrawer
 *
 * Responsive drawer/popover for the Refer & Earn promotion.
 *
 * Behavior:
 * - Mobile: Bottom sheet with swipe-to-dismiss, minimizes to FAB
 * - Desktop: Centered popover modal, closes completely on dismiss
 *
 * Usage:
 * Simply render this component on the homepage. It includes its own
 * provider and manages its own state internally.
 *
 * ```tsx
 * // In your page component
 * <ReferEarnDrawer />
 * ```
 */
export const ReferEarnDrawer: React.FC = () => {
  return (
    <ReferEarnDrawerProvider>
      <ReferEarnDrawerPrivate />
    </ReferEarnDrawerProvider>
  );
};
